<!--
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-16 10:36:35
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-03-17 10:54:31
 -->
<template>
  <div id="product-monitor-container">
    <NavMenu />
    <div class="productContent">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import NavMenu from '@/components/NavMenu'
export default {
  name: 'ProductMonitor',
  components: {
    NavMenu,
  },
  data () {
    return {
    }
  },
  methods: {
  },
  created () {
  },
}
</script>

<style lang="less" scoped>
  #product-monitor-container {
    width: 100%;
    height: 100%;
    position: relative;
    .productContent {
      width: 100%;
      height: 100%;
    }
  }
</style>
